import React, { useState } from "react";
import { TableContainer, CircularProgress } from "@material-ui/core";
import { Calendar as BigCalendar, momentLocalizer } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import moment from "moment";
import "moment/locale/zh-tw";
import NavigateBefore from "@material-ui/icons/NavigateBefore";
import NavigateNext from "@material-ui/icons/NavigateNext";
import { useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";

import Grid from "./Grid";
import Text from "./Text";
import { Select } from "./Form";
import { propertyDataArray } from "./PropertyDataArray";
import { Card, CardContent } from "./Card";
import { useAlert } from "./Alert";

const GET_FORECLOSURECALENDAR = gql`
  query foreclosureCalendar($obj_court: String!, $year: Int!, $month: Int!) {
    foreclosureCalendar(obj_court: $obj_court, year: $year, month: $month) {
      newCount
      newContents {
        obj_no
      }
      foreclosureCount
      foreclosureContents {
        obj_no
      }
      bidCount
      bidContents {
        obj_no
      }
    }
  }
`;

export let navigate = {
  PREVIOUS: "PREV",
  NEXT: "NEXT",
};

const localizer = momentLocalizer(moment);
let today = new Date();
let y = today.getFullYear();
let m = today.getMonth();
let d = today.getDate();

class CustomToolbar extends React.Component {
  render() {
    let { label } = this.props;
    return (
      <div className="rbc-toolbar">
        <span className="rbc-btn-group">
          <button
            type="button"
            onClick={this.navigate.bind(null, navigate.PREVIOUS)}
          >
            <NavigateBefore fontSize={"small"} />
          </button>
        </span>
        <Text className="rbc-toolbar-label" type="h5">
          {label}
        </Text>
        <span className="rbc-btn-group">
          <button
            type="button"
            onClick={this.navigate.bind(null, navigate.NEXT)}
          >
            <NavigateNext fontSize={"small"} />
          </button>
        </span>
      </div>
    );
  }
  navigate = (action) => {
    this.props.onNavigate(action);
  };
}

export default function Calendar4Table() {
  const Alert = useAlert();
  const [theCourtObject, setTheCourtObject] = useState({
    label: "臺灣臺中地方法院",
    value: "TCD",
  });
  const { courtArray } = propertyDataArray();
  const [year, setYear] = useState(new Date().getFullYear());
  const [month, setMonth] = useState(new Date().getMonth());
  const [events, setEvents] = useState([]);
  const { loading } = useQuery(GET_FORECLOSURECALENDAR, {
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
    variables: {
      obj_court: theCourtObject.value,
      year: year,
      month: month,
    },
    onCompleted({ foreclosureCalendar }) {
      if (foreclosureCalendar) {
        let newEvents = [];
        foreclosureCalendar.newCount.forEach((item, index) => {
          newEvents.push(
            {
              title: `新增：${foreclosureCalendar.newCount[index]}件`,
              allDay: true,
              start: new Date(year, month, index + 1),
              end: new Date(year, month, index + 1),
              color: "green",
              data: foreclosureCalendar.newContents[index],
            },
            {
              title: `法拍：${foreclosureCalendar.foreclosureCount[index]}件`,
              allDay: true,
              start: new Date(year, month, index + 1),
              end: new Date(year, month, index + 1),
              color: "default",
              data: foreclosureCalendar.foreclosureContents[index],
            },
            {
              title: `得標：${foreclosureCalendar.bidCount[index]}件`,
              allDay: true,
              start: new Date(year, month, index + 1),
              end: new Date(year, month, index + 1),
              color: "red",
              data: foreclosureCalendar.bidContents[index],
            }
          );
        });
        setEvents(newEvents);
      }
    },
    onError(error) {
      Alert.alert("通知", `${error}`, [
        {
          text: "確定",
          type: "ok",
        },
      ]);
    },
  });
  const eventColors = (event) => {
    // const backgroundColor = event.color === "default" ? "#16508B" : "#00A7AB";
    const backgroundColor = (() => {
      switch (event.color) {
        case "default":
          return "#16508B";
        case "green":
          return "#00A7AB";
        case "red":
          return "#d50000";
        default:
          break;
      }
    })();
    var style = {
      backgroundColor: backgroundColor,
      borderRadius: "0px",
      opacity: 0.8,
      color: "white",
      border: "0px",
      display: "block",
    };
    return {
      style: style,
    };
  };
  if (loading) {
    return (
      <Grid container item justify="center">
        <CircularProgress color="secondary" />
      </Grid>
    );
  } else {
    return (
      <Card>
        <CardContent>
          <Grid container spacing={1} justify="center">
            <Grid item xs={12} sm={3}>
              <Select
                placeholder={"請選擇法院"}
                variant={"outlined"}
                items={courtArray}
                value={theCourtObject}
                onChange={(e, value) => {
                  if (value) {
                    setTheCourtObject(value);
                  } else {
                    setTheCourtObject({
                      label: "臺灣臺中地方法院",
                      value: "TCD",
                    });
                  }
                }}
                fullWidth
              />
            </Grid>
          </Grid>
        </CardContent>
        <CardContent>
          <TableContainer>
            <BigCalendar
              localizer={localizer}
              events={events}
              startAccessor="start"
              endAccessor="end"
              style={{
                display: "flex",
                height: "100%",
                minHeight: "100vh",
                width: "100%",
                minWidth: 892,
              }}
              components={{
                toolbar: CustomToolbar,
              }}
              eventPropGetter={eventColors}
              onNavigate={(e) => {
                setYear(new Date(e).getFullYear());
                setMonth(new Date(e).getMonth());
              }}
              onSelectEvent={(event, i) => {
                window.open(
                  `/console/sale-obj-search-results`,
                  "_blank",
                  "noopener"
                );
                localStorage.setItem(
                  "@fullhouseEventData",
                  JSON.stringify(event.data)
                );
              }}
            />
          </TableContainer>
        </CardContent>
      </Card>
    );
  }
}
